// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type InvoicesPageQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.InvoiceFilter>;
  order?: Types.InputMaybe<Types.InvoiceOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type InvoicesPageQuery = { __typename?: 'Query', invoicesPage: { __typename?: 'InvoicesPage', entities: Array<{ __typename?: 'Invoice', id: string, title: string, invoiceNumber: string, dueDate: Types.Scalars['Date']['input'], invoiceDate: Types.Scalars['Date']['input'], amountInCents: number, amountPaidInCents: number, balanceInCents: number, paidDate?: Types.Scalars['Date']['input'] | null | undefined, project:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      , status: { __typename?: 'InvoiceStatusDetail', code: Types.InvoiceStatus, name: string } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type InvoicesPageInvoiceFragment = { __typename?: 'Invoice', id: string, title: string, invoiceNumber: string, dueDate: Types.Scalars['Date']['input'], invoiceDate: Types.Scalars['Date']['input'], amountInCents: number, amountPaidInCents: number, balanceInCents: number, paidDate?: Types.Scalars['Date']['input'] | null | undefined, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  , status: { __typename?: 'InvoiceStatusDetail', code: Types.InvoiceStatus, name: string } };

export const InvoicesPageInvoiceFragmentDoc = gql`
    fragment InvoicesPageInvoice on Invoice {
  id
  title
  invoiceNumber
  dueDate
  invoiceDate
  amountInCents
  amountPaidInCents
  balanceInCents
  paidDate
  project {
    ...Named
  }
  status {
    code
    name
  }
}
    ${NamedFragmentDoc}`;
export const InvoicesPageDocument = gql`
    query InvoicesPage($filter: InvoiceFilter, $order: InvoiceOrder, $page: PageFilter) {
  invoicesPage(filter: $filter, order: $order, page: $page) {
    entities {
      ...InvoicesPageInvoice
    }
    pageInfo {
      totalCount
    }
  }
}
    ${InvoicesPageInvoiceFragmentDoc}`;

/**
 * __useInvoicesPageQuery__
 *
 * To run a query within a React component, call `useInvoicesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useInvoicesPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InvoicesPageQuery, InvoicesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicesPageQuery, InvoicesPageQueryVariables>(InvoicesPageDocument, options);
      }
export function useInvoicesPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicesPageQuery, InvoicesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicesPageQuery, InvoicesPageQueryVariables>(InvoicesPageDocument, options);
        }
// @ts-ignore
export function useInvoicesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InvoicesPageQuery, InvoicesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoicesPageQuery, InvoicesPageQueryVariables>;
export function useInvoicesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicesPageQuery, InvoicesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoicesPageQuery | undefined, InvoicesPageQueryVariables>;
export function useInvoicesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicesPageQuery, InvoicesPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoicesPageQuery, InvoicesPageQueryVariables>(InvoicesPageDocument, options);
        }
export type InvoicesPageQueryHookResult = ReturnType<typeof useInvoicesPageQuery>;
export type InvoicesPageLazyQueryHookResult = ReturnType<typeof useInvoicesPageLazyQuery>;
export type InvoicesPageSuspenseQueryHookResult = ReturnType<typeof useInvoicesPageSuspenseQuery>;
export type InvoicesPageQueryResult = Apollo.QueryResult<InvoicesPageQuery, InvoicesPageQueryVariables>;